(function () {
  'use strict';

  const MOVIMENTO_OFFSET = {
    'Topo para baixo': { y: -60 },
    'Baixo para topo': { y: 60 },
    'Esquerda para direita': { x: -60 },
    'Direita para esquerda': { x: 60 },
  };

  function initMovimento() {
    if (typeof window.gsap === 'undefined' || typeof window.ScrollTrigger === 'undefined') return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    gsap.registerPlugin(ScrollTrigger);

    document.querySelectorAll('.gcl-item[data-movimento]').forEach((item) => {
      const offset = MOVIMENTO_OFFSET[item.dataset.movimento];
      if (!offset) return; // "Sem movimento" ou valor desconhecido: sem animação

      gsap.from(item, {
        ...offset,
        opacity: 0,
        duration: 0.8,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: item,
          start: 'top 85%',
          toggleActions: 'play none none reverse',
        },
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMovimento);
  } else {
    initMovimento();
  }
})();
